'use strict';

var tealium = require('../tealium');

var cart = {
    init: function() {
        //Cart Remove
        $('button[name$="deleteProduct"]').on('click', cart.cartRemove);    
        

    },
    cartRemove: function() {
		var data = {
			event_name:"cart-removal"
		};
		tealium.triggerEvent(data);
    },
};

exports.init = cart.init;
